import {head} from 'ramda';

import {LeasingRateMatrixCell, SaveSaleVehicleLeasingBody} from '@dms/api/vehicle';

import {compareLeasingCells} from './compareLeasingCells';
import {isActiveLeasingCell} from './isActiveLeasingCell';
import {isSameLeasingCell} from './isSameLeasingCell';

export function removeLeasingCell(
  vehicleLeasingBody: SaveSaleVehicleLeasingBody,
  cellToRemove: LeasingRateMatrixCell
): SaveSaleVehicleLeasingBody {
  const isActiveCell = isActiveLeasingCell(vehicleLeasingBody, cellToRemove);
  const nextCells = vehicleLeasingBody.rateMatrixCells.filter(
    (cell) => !isSameLeasingCell(cell, cellToRemove)
  );
  const fallbackActiveCell = isActiveCell ? head([...nextCells].sort(compareLeasingCells)) : null;

  return {
    ...vehicleLeasingBody,
    activeTerm: fallbackActiveCell?.term ?? (isActiveCell ? null : vehicleLeasingBody.activeTerm),
    activeAnnualMileage:
      fallbackActiveCell?.annualMileage ??
      (isActiveCell ? null : vehicleLeasingBody.activeAnnualMileage),
    rateMatrixCells: nextCells,
  };
}
